"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.XHRPlugin401 = void 0;
const messages_1 = require("../../../xhr/messages");
/**
 *
 * @deprecated please use from web-ui-security instead
 * @link https://github.com/santander-group-ods/SOFTWEB-web-ui-security | web-ui-security
 *
 */
class XHRPlugin401 {
    constructor() {
        // debug = true;
        this.name = this.constructor.name;
    }
    handleResponse(response) {
        if (response.data && response.data.httpStatus === 401) {
            response.data.message = messages_1.XHRMessages.XHR_SERVICE_UNAUTHORIZED;
            response.data.ok = false; // enforce
        }
        return Promise.resolve(response);
    }
}
exports.XHRPlugin401 = XHRPlugin401;
//# sourceMappingURL=401.js.map